JST["quick-reorder__header"] = function anonymous(it
) {
var out='<header class="text-center"> ';if(it.hasHomeTrialOrder){out+=' <h1 class="m-0">'+( texts('headerHomeTrial@quickReorder'))+'</h1> ';}else{out+=' <h1 class="m-0">'+( texts('header@quickReorder'))+'</h1> ';}out+='</header>';return out;
};